import { AddressRequest } from "@/main/models/request";
import { AddressByBodyshopTypes, AddressByBodyshopActionTypes } from "./addressByBodyshopTypes";
import { AddressByBodyshopResponse } from "@/main/models/response";

export function getAddressByBodyshop(request: AddressRequest): AddressByBodyshopActionTypes {
	return {
		type: AddressByBodyshopTypes.GET_ADDRESSBYBODYSHOP,
		payload: { request },
	};
}

export function saveAddressByBodyshop(
	data: AddressByBodyshopResponse[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): AddressByBodyshopActionTypes {
	return {
		type: AddressByBodyshopTypes.SAVE_ADDRESSBYBODYSHOP,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerAddressByBodyshop(): AddressByBodyshopActionTypes {
	return {
		type: AddressByBodyshopTypes.RESET_REDUCER_ADDRESSBYBODYSHOP,
	};
}
